import { useIntl } from 'react-intl';

export const useSharedStrings = () => {
  const intl = useIntl();

  const getCategoryMessage = (stringKey: string) => {
    switch (stringKey) {
      case 'analytics-reporting':
        return intl.formatMessage({
          id: 'templates.directory.analytics-reporting',
          defaultMessage: 'Analytics &amp; reporting',
          description: 'Analytics & Reporting category',
        });
      case 'automation':
        return intl.formatMessage({
          id: 'templates.directory.automation',
          defaultMessage: 'Automation',
          description: 'Automation category',
        });
      case 'board-utilities':
        return intl.formatMessage({
          id: 'templates.directory.board-utilities',
          defaultMessage: 'Board utilities',
          description: 'Board Utilities category',
        });
      case 'communication-collaboration':
        return intl.formatMessage({
          id: 'templates.directory.communication-collaboration',
          defaultMessage: 'Communication &amp; collaboration',
          description: 'Communication & Collaboration category',
        });
      case 'developer-tools':
        return intl.formatMessage({
          id: 'templates.directory.developer-tools',
          defaultMessage: 'Developer tools',
          description: 'Developer Tools category',
        });
      case 'file-management':
        return intl.formatMessage({
          id: 'templates.directory.file-management',
          defaultMessage: 'File management',
          description: 'File Management category',
        });
      case 'hr-operations':
        return intl.formatMessage({
          id: 'templates.directory.hr-operations',
          defaultMessage: 'HR &amp; operations',
          description: 'HR & Operations category',
        });
      case 'it-project-management':
        return intl.formatMessage({
          id: 'templates.directory.it-project-management',
          defaultMessage: 'IT &amp; project management',
          description: 'IT & Project Management category',
        });
      case 'marketing-social-media':
        return intl.formatMessage({
          id: 'templates.directory.marketing-social-media',
          defaultMessage: 'Marketing &amp; social media',
          description: 'Marketing & Social Media category',
        });
      case 'product-design':
        return intl.formatMessage({
          id: 'templates.directory.product-design',
          defaultMessage: 'Product &amp; design',
          description: 'Product Design category',
        });
      case 'sales-support':
        return intl.formatMessage({
          id: 'templates.directory.sales-support',
          defaultMessage: 'Sales &amp; support',
          description: 'Sales & Support category',
        });
      default:
        return null;
    }
  };

  return {
    getCategoryMessage,
  };
};
